import { createAsyncThunk } from "@reduxjs/toolkit";
import { shopModulesApi } from "../../api/shopModulesApi";
import { handleRequest } from "../utils/handleRequest";
import { AppDispatch, RootState } from "../store";
import { ShopModule } from "../../types/shopModuleTypes";

export const fetchShopModulesThunk = createAsyncThunk<
  ShopModule[],
  void,
  { dispatch: AppDispatch; state: RootState; rejectValue: string }
>(
  "shopModules/fetchShopModules",
  async (_, { dispatch, rejectWithValue }) => {
    const callResult = await handleRequest(
      dispatch,
      "indirect",
      () => shopModulesApi.getCompanyShopModules()
    );
    if (!callResult.success()) {
      return rejectWithValue(callResult.errorMessage ?? "Failed to fetch shop modules");
    }
    return callResult.result as ShopModule[];
  }
);